import { GET } from 'utils/requests.utils'
import { getElopageConfig } from 'utils/elopageConfig.utils'

const apiPathCommunity = getElopageConfig('apiPathCommunity')

const BASE_URL = `${apiPathCommunity}/v1/members`

export const fetchList = (data) => GET(BASE_URL, data)
